import axios from 'axios';
// ref: https://vitejs.dev/guide/features.html#transpile-only
import type { AxiosInstance } from 'axios';
import { VITE_APIGEE_BASE_URL } from './constants/envConstants';
import { getAuthTokenFromSession } from './helpers';

export const requestHandler = ({
  // Can override axios instance variables from an individual action
  // by passing them as params here
  // ref: https://axios-http.com/docs/req_config
  baseURL = VITE_APIGEE_BASE_URL,
  customHeaders = {},
  skipAuthToken = false,
}: {
  baseURL?: string;
  customHeaders?: object;
  skipAuthToken?: boolean;
}): AxiosInstance => {
  const authToken = getAuthTokenFromSession();
  let headerSettings = {};
  if (skipAuthToken) {
    headerSettings = {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...customHeaders,
    };
  } else {
    headerSettings = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
      ...customHeaders,
    };
  }

  return axios.create({
    baseURL,
    headers: headerSettings,
  });
};
